import React from "react";
import {Box, Text} from "@chakra-ui/react";
import {useChat} from "@/components/providers/ChatProvider";

const splitToChunks = (text) => {
    const chunks = text.split(/(\{#.*?\})/g).filter(part => part !== "");
    const result = chunks.map(chunk => ({
        value: chunk,
        isDynamic: chunk.startsWith("{#") && chunk.endsWith("}")
    }));

    return result;
}

const ApiBubble = ({message}) => {
    const { tagRegistry = {} } = useChat();
    const renderContent = () => {
        const chunks = splitToChunks(message?.text || '');
        return chunks.map((chunk, i) => {
            if (chunk.isDynamic) {
                const tagName = chunk.value.slice(1, -1);
                const renderer = tagRegistry[tagName];
                
                if (renderer) {
                    return <React.Fragment key={i}>{renderer(message.result)}</React.Fragment>;
                }
                
                return null;
            }
            return chunk.value.trim()
                ? <Text key={i} fontSize={14}>{chunk.value}</Text>
                : null;
        });
    };

    return (
        <Box display={'flex'} justifyContent={'center'} w={'full'} py={2}>
            <Box bg={'gray.900'} borderWidth={1} borderColor={'border.primary'}
                 color={'white'} borderRadius={'md'} p={3} maxW={'90%'} w={'full'}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default ApiBubble;
